import React from 'react'
import * as styles from './NoDealsInfo.css'

export const NoDealsInfo = ({ header, description, icon = '🧾' }) => {
  header = header ? header : 'No deals found'

  return (
    <div className={styles.noDealsInfo}>
      <div className={styles.icon}>{icon}</div>
      <div className={styles.title}>{header}</div>
      {description && <p className={styles.desc}>{description}</p>}
    </div>
  )
}
